// Product Category
import { connect } from 'react-redux';
import * as FilterActions from '../../actions/filter-actions';
import BlogArticles from './BlogArticles';

const mapStateToProps = state => ({
  filters: state.filters,
  articleItems: state.articleItems,
  noResultsMessage: state.noResultsMessage,
  articlesListLinkText: state.articlesListLinkText,
  selectedFilters: state.selectedFilters,
  filterToggle: state.filterToggle,
  searchText: state.searchText,
});

const mapDispatchToProps = dispatch => ({
  buttonClick: (event, filterName) => dispatch(FilterActions.buttonClick(event, filterName)),
  closeAllDropdowns: event => dispatch(FilterActions.closeAllDropdowns(event)),
  filterClick: option => dispatch(FilterActions.filterClick(option)),
  filterToggleClick: () => dispatch(FilterActions.filterToggleClick()),
  applyBlogFilters: pendingSelectedFilters => dispatch(FilterActions.applyBlogFilters(pendingSelectedFilters)),
  closeFilterPanel: () => dispatch(FilterActions.closeFilterPanel()),
  searchSubmit: searchText => dispatch(FilterActions.searchSubmit(searchText)),
  removeFilter: filterName => dispatch(FilterActions.removeFilter(filterName)),
  clearFilters: () => dispatch(FilterActions.clearFilters()),
});

const BlogArticlesContainer = connect(mapStateToProps, mapDispatchToProps)(BlogArticles);

export default BlogArticlesContainer;
